import React from 'react'
import { useHistory } from 'react-router-dom'

import { useGeoState } from '../GeoProvider'
import DropDownList from '../DropDownList'
import { useAuthState } from '../AuthProvider'
import styles from './MapOptions.module.scss'
import Search from '../../components/Search' 
import dayjs from 'dayjs'
// import Content from '../Content'
// import Tooltip from '../Tooltip'
// import Button from '../../components/ButtonExport'
// import Icon from '../../components/Icon'
// import ButtonExport from '../../components/ButtonExport'

import { CSVLink } from 'react-csv'
// import json2csv from "json2csv";
// import { color } from 'highcharts'

const MapOptions = ({
  regionDisplayOptions,
  dataDisplayOptions,
  activeCbsa,
  exportData = null,
  mapType,
  searchPlaceholder = 'Search State, MSA or Zip 3',
}) => {
  let displayDateWeekEnd = dayjs().day(13).format('YYYY-MM-DD')
  const longText = `Hospital referral regions (HRRs) are geographic delineations created by the Dartmouth Atlas of Health Care (an organization committed to studying healthcare markets in the United States) to clearly define unique healthcare market regions. HRRs are made up of zip code area groupings based on the referral patterns of tertiary medical care.`
  const {
    displayDate,
    mapOptions,
    setMapOptions,
    dataSelected,
    setDataSelected,
    regionSelected,
    setRegionSelected,
    loadedDate,
    UHCStateLoadedDate,
    UHCCountyLoadedDate,
    setDisplayDate,
     exportButtonState,setExportButtonState,exportButtonEnable
  } = useGeoState()
  const [searchCriteria, setSearchCriteria] = React.useState([])
  const handleClick = () => {
    setExportButtonState(true)
  }
  const getDisplayDate = (value) => {
    if (value['parent'] === mapOptions['parent']) {
      return displayDate
    } else {
      switch (value['parent']) {
        case 'UHC Indicators':
          if (regionSelected === 'state') {
            return UHCStateLoadedDate
          } else {
            return UHCCountyLoadedDate
          }
        default:
          return loadedDate
      }
    }
  }

  const resetDisplayDate = (value) => {
    switch (mapOptions['parent']) {
      case 'UHC Indicators':
        if (value === 'state' || value === 'metro') {
          return UHCStateLoadedDate
        } else {
          return UHCCountyLoadedDate
        }
      default:
        return loadedDate
    }
  }

  const history = useHistory()
  const { user } = useAuthState()
  let displayOptions = dataDisplayOptions.filter(
    (option) =>
      !option['allowedRoles'] || option['allowedRoles'].includes(user.role)
  )
  // below added BY Avanish for getting export csv
  const exportCsv = () => {
    //console.log(exportData)
  }
  var expdata = `2022-09-10 AK
weekly_cases,daily_cases_rolling_7day, weekly_cases_per_100k, daily_cases_rolling_7day_per_100k, population, cast_type
1247,0,170,10, 731545,Forecast
950,2,154,6, 731545,Forecast
765,5,134,12, 731545,Forecast
1400,1,112,10, 731545,Forecast
1230,7,187,10, 731545,Forecast
`

  return mapType == 'HRR' ? (
    <div className={styles.base}>
      <div className={styles.displayHRR}>
        <p
          style={{
            marginBottom: '5px',
            fontFamily: 'graphik',
            fontSize: '14px',
            color: '#424242',
            fontWeight: 500,
          }}
        >
          {' '}
          DISPLAY {'  '}{' '}
        </p>
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            history.push({ hash: null })
            setRegionSelected(e.target.value)
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
      </div>
      <div className={styles.exportHRR}>
        <CSVLink
          data={expdata}
          filename={'covid.csv'}
          className="styles.export"
          target="_blank"
          style={{
            color: '#424242',
            fontFamily: 'graphik',
            fontSize: '14px',
          }}
        >
          Export this
          <span style={{ marginLeft: '5px' }}>
            <svg
              width="20"
              height="13"
              viewBox="0 0 20 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
            >
              <rect width="20" height="13" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    href="#image0_0_2212"
                    transform="scale(0.025 0.0384615)"
                  />
                </pattern>
                <image
                  id="image0_0_2212"
                  width="40"
                  height="26"
                  href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </span>
        </CSVLink>
      </div>
    </div>
  ) : mapType == 'FLUMAP' ? (
    <div className={styles.base}>
      <div className={styles.displayFlu}>
        <p
          style={{
            marginBottom: '5px',
            fontFamily: 'graphik',
            fontSize: '14px',
            color: '#424242',
            fontWeight: 500,
          }}
        >
          {' '}
          DISPLAY{'  '}{' '}
        </p>
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            history.push({ hash: null })
            setRegionSelected(e.target.value)
            //setDisplayDate(resetDisplayDate(e.target.value))
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
      </div>

      <div className={styles.exportFlu}>
        <CSVLink
          data={expdata}
          filename={'covid.csv'}
          className="styles.export"
          target="_blank"
          style={{
            color: '#424242',
            fontFamily: 'graphik',
            fontSize: '14px',
          }}
        >
          Export this
          <span style={{ marginLeft: '5px' }}>
            <svg
              width="20"
              height="13"
              viewBox="0 0 20 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
            >
              <rect width="20" height="13" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    href="#image0_0_2212"
                    transform="scale(0.025 0.0384615)"
                  />
                </pattern>
                <image
                  id="image0_0_2212"
                  width="40"
                  height="26"
                  href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </span>
        </CSVLink>
      </div>
    </div>
  ) : (mapType.toLowerCase() == 'covid' || mapType.toLowerCase() == 'rsv' || mapType.toLowerCase() == 'vulnerability') ? (
    <div className={styles.base}>
      <div className={styles.pageRegionList}>
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            // history({ hash: null })
            setRegionSelected(e.target.value)
            if (
              displayDate > displayDateWeekEnd &&
              e.target.value !== 'zip3' &&
              mapType !== 'Vulnerability'
            ) {
              setDisplayDate(displayDateWeekEnd)
            }
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
       </div>
      <div className={styles.pageHeaderSearch}>
            {activeCbsa !== undefined && (
               <Search
            criteria={searchCriteria}
            onChange={setSearchCriteria}
            placeholder={searchPlaceholder}
            entity={mapType}
            activeMetros={activeCbsa}
            activeZip3={null}
          />
            )}
          </div>
        <div className={styles.pageHeaderExport}>
          {mapType.toLowerCase() != 'vulnerability'?
        exportButtonState===true || exportButtonEnable===false?
         <button className={styles.buttonClassDisable}>Export</button>:
         <button className={styles.buttonClass} onClick={() => {handleClick()}}>Export</button>
          :''
          }
       
      </div>
     </div>
  ):(
    <div className={styles.base}>
      <div className={styles.showme}>
        <p style={{ marginBottom: '5px',fontFamily: 'graphik',height:'16px',
            fontSize: '14px',
            color: '#424242',
            fontWeight: 500, }}>SHOW ME{'  '}</p>
        <DropDownList
          id="data"
          name="data"
          onChange={(e) => {
            let value = []
            displayOptions.forEach((options) => {
              value = [
                ...value,
                ...options['options'].filter((o) => o.value === e.target.value),
              ]
            })
            history.push({ hash: null })
           // setDisplayDate(getDisplayDate(value[0]))
            setMapOptions(value[0])

            setDataSelected(e.target.value)
            if (e.target.value == 'hospital_admissions') {
              setRegionSelected('hrr')
            } else {
              setRegionSelected('state')
            }
          }}
          className={styles.dropDowns}
          defaultValue={dataSelected}
        >
          {displayOptions.length > 1
            ? displayOptions.map((option) => {
                return (
                  <DropDownList.OptionGroup
                    label={option['label']}
                    key={option['label']}
                  >
                    {option['options'].map((data) => {
                      return (
                        <DropDownList.Item value={data.value} key={data.value}>
                          {data.label}
                        </DropDownList.Item>
                      )
                    })}
                  </DropDownList.OptionGroup>
                )
              })
            : displayOptions.map((option) => {
                return option['options'].map((data) => {
                  return (
                    <DropDownList.Item value={data.value} key={data.value}>
                      {data.label}
                    </DropDownList.Item>
                  )
                })
              })}
        </DropDownList>
      </div>
      <div className={styles.display}>
        <p
          style={{
            marginBottom: '5px',
            fontFamily: 'graphik',
            fontSize: '14px',
            color: '#424242',
            fontWeight: 500,height:'16px'
          }}
        >
          {' '}
          DISPLAY {'  '}{' '}
        </p>
        <DropDownList
          id="regions"
          name="regions"
          onChange={(e) => {
            history.push({ hash: null })
            setRegionSelected(e.target.value)
           // setDisplayDate(resetDisplayDate(e.target.value))
          }}
          className={styles.dropDowns}
          defaultValue={regionSelected}
        >
          {regionDisplayOptions.map((regions, regionsIndex) => {
            return (
              <DropDownList.Item
                value={regions.value}
                key={regions.value}
                selected={regionSelected === regions.value}
              >
                {regions.label}
              </DropDownList.Item>
            )
          })}
        </DropDownList>
      </div>

      <div className={styles.export}>
        <CSVLink
          data={expdata}
          filename={'covid.csv'}
          className="styles.export"
          target="_blank"
          style={{
            color: '#424242',
            fontFamily: 'graphik',
            fontSize: '14px',
          }}
        >
          Export this
          <span style={{ marginLeft: '5px' }}>
            <svg
              width="20"
              height="13"
              viewBox="0 0 20 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
            >
              <rect width="20" height="13" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    href="#image0_0_2212"
                    transform="scale(0.025 0.0384615)"
                  />
                </pattern>
                <image
                  id="image0_0_2212"
                  width="40"
                  height="26"
                  href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </span>
        </CSVLink>
      </div>
    </div>
  )
}

export default MapOptions